import {FC, useCallback, useEffect, useMemo, useRef} from 'react'
import {AgGridReact} from 'ag-grid-react'
import {} from '@ag-grid-community/core'
import {ColDef, ColGroupDef, ServerSideStoreType} from 'ag-grid-community'
import {useBetween} from 'use-between'
import {BTGlobal} from '../BTglobal/BTGlobal'
import {AllCommunityModules} from '@ag-grid-community/all-modules'

const AgGridTable2: FC<AgGridTableProps2> = (props) => {
  const {setBtGridRef} = useBetween(BTGlobal)
  const gridRef = useRef<any>(null)
  const gridStyle = useMemo(() => ({height: '60vh', width: '100%'}), [])
  const containerStyle = useMemo(() => ({width: '100%', height: '100%'}), [])
  useEffect(() => {
    if (props.dataRow !== undefined && props.setAGGridRef) {
      if (props.dataRow.length > 0) {
        setTimeout(() => {
          props.setAGGridRef(gridRef)
        }, 500)
      }
    }
  }, [props.isRefreshGrid])
  const module: any = AllCommunityModules
  const defaultColDef = useMemo(() => {
    return {
      width: 150,
      sortable: false,
      filter: true,
      resizable: true,
    }
  }, [])

  if (props.isRefreshGrid === true) {
    setTimeout(() => {
      setBtGridRef(gridRef)
    }, 300)
  }
  const onRowDrag = useCallback((event: any) => {
    setTimeout(() => {
      setBtGridRef(gridRef)
      return props.onRowDrag ? props.onRowDrag(event, gridRef) : undefined
    }, 700)
  }, [])
  try {
    if (gridRef.current) props.setAGGridRef(gridRef)
  } catch (error) {}
  return (
    <div style={containerStyle}>
      <div
        style={gridStyle}
        className={`ag-theme-alpine popup_minuta border-0 table-contract step2-ag-grid2 ${
          props.className || ''
        }`}
      >
        <AgGridReact
          ref={gridRef}
          onRowDragEnd={onRowDrag}
          modules={module}
          onRowDragEnter={props.onRowDragEnter}
          columnDefs={props.columnDefs}
          rowHeight={props.rowHeight || 90}
          defaultColDef={defaultColDef}
          rowDragManaged={true}
          animateRows={true}
          rowData={props.dataRow}
          getRowStyle={props.getRowStyle}
        />
      </div>
    </div>
  )
}
AgGridTable2.defaultProps = {
  pagination: true,
  paginationPageSize: 10,
  rowDrag: false,
}
interface AgGridTableProps2 {
  columnDefs?: (ColDef | ColGroupDef)[] | undefined
  rowHeight?: number
  onRowDragEnter?(e: any): void
  style?: React.CSSProperties | undefined
  className?: string | undefined
  defaultColDef?: any
  rowDragManaged?: any
  getRowStyle?: any
  dataRow?: any
  rowDrag?: boolean
  rowPinned?: any
  rowClassRules?: any
  serverSideStoreType?: ServerSideStoreType
  pagination?: boolean
  paginationPageSize?: number
  setAGGridRef?: any
  cacheBlockSize?: number
  animateRows?: boolean
  onGridReady?: any
  onRowDrag?(e: any, gridRef: any): void | undefined
  onClick?(row: any, dataGrid: React.MutableRefObject<any>, event: any): void | undefined
  onChange?(row: any, dataGrid: React.MutableRefObject<any>, event: any): void | undefined
  onCellValueChanged?(params: any): void
  isRefreshGrid?: boolean
  suppressRowClickSelection?: boolean
  suppressRowDeselection?: boolean
  rowMultiSelectWithClick?: boolean
  rowSelection?: string
}
export interface columnDefsProps2 {
  field?: string
  headerName?: string
  minWidth?: string
  editable?: boolean
  cellEditorParams?: any
  cellRenderer?: void
}
export {AgGridTable2}
